import React from 'react';
import { ArmchairIcon as Chair, Wind, Sun, Users, Shield } from 'lucide-react';

const BusSection = () => {
  const features = [
    {
      icon: Chair,
      title: 'Poltronas Reclináveis',
      description: 'Assentos confortáveis para você descansar durante a viagem'
    },
    {
      icon: Wind,
      title: 'Ar-Condicionado',
      description: 'Temperatura controlada para máximo conforto'
    },
    {
      icon: Sun,
      title: 'Iluminação Adequada',
      description: 'Perfeita para viagens noturnas tranquilas'
    },
    {
      icon: Users,
      title: 'Espaço Interno',
      description: 'Amplo e confortável para longas distâncias'
    },
    {
      icon: Shield,
      title: 'Guias Especializados',
      description: 'Acompanhamento profissional durante toda a jornada'
    }
  ];

  return (
    <section className="py-20 bg-gray-900 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="animate-slide-in-left">
            <div className="inline-block bg-red-600 text-white px-4 py-2 rounded-full mb-6">
              <span className="font-semibold">Conforto e Segurança</span>
            </div>
            
            {/* Logo */}
            <img 
              src="https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/137t1god_LOGO%20AR%20BRANCA%20SOMBRA.png" 
              alt="A.R. Turismo" 
              className="h-16 w-auto mb-6"
            />
            
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              Ônibus <span className="text-red-500">Executivo</span> Confortável
            </h2>
            <p className="text-xl text-gray-300 mb-8 leading-relaxed">
              A viagem rodoviária para Porto Seguro é realizada em <strong className="text-white">ônibus executivo confortável</strong>, 
              pensado para longos trajetos, oferecendo mais comodidade e segurança aos passageiros.
            </p>

            {/* Features List */}
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-4 p-4 bg-white/5 backdrop-blur-sm rounded-xl hover:bg-white/10 transition-all duration-300"
                >
                  <div className="w-12 h-12 bg-red-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg mb-1">{feature.title}</h3>
                    <p className="text-gray-400 text-sm">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="animate-slide-in-right">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-red-600 to-orange-500 rounded-3xl blur-2xl opacity-20"></div>
              <img
                src="https://customer-assets.emergentagent.com/job_turismo-landing-ar/artifacts/suci4b7e_ONIBUS%20EXECUTIVO.jpeg"
                alt="Ônibus Executivo A.R. Turismo"
                className="relative rounded-2xl shadow-2xl w-full h-auto object-cover"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-black/70 backdrop-blur-md p-4 rounded-xl">
                <p className="text-white font-semibold text-center">
                  Ônibus Executivo de Luxo - Máximo Conforto para sua Viagem
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusSection;
